class Idioma
{
  idIdioma = 0;
  idioma = 0;
  clave = "";
  usuario = "";

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = Idioma;
